var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget--line_chart"},[_c('canvas',{ref:"chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }